import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { faqs } from "../mock";
import useReveal from "../hooks/useReveal";

export default function FAQ() {
  const [ref, inView] = useReveal();

  return (
    <section id="faq" className="bg-[#EAE9F6] py-16">
      <div
        ref={ref}
        className={`reveal ${inView ? "in-view" : ""} mx-auto max-w-3xl px-5 md:px-8`}
      >
        <p className="text-center text-xs font-extrabold tracking-[0.15em] text-[#990EE5]">
          GOT QUESTIONS?
        </p>
        <h2 className="mt-2 text-center font-serif-display text-3xl font-bold text-[#6618D0] md:text-[2.3rem]">
          Frequently Asked Questions
        </h2>

        <Accordion type="single" collapsible className="mt-8 space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="overflow-hidden rounded-xl border border-[#D8CFF0] bg-white px-5"
            >
              <AccordionTrigger className="text-left font-serif-display text-[16px] font-bold text-[#6618D0] hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[14px] leading-relaxed text-[#5a5a5a]">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
